(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
  const applyContactReturnIntent = () => {
    const form = document.getElementById('ContactForm');
    if (!form || form.querySelector('[data-contact-posted]')) return;

    const params = new URLSearchParams(window.location.search);
    const hash = window.location.hash.replace(/^#/, '').toLowerCase();
    const isReturn =
      params.get('intent') === 'return' || hash === 'returns' || hash === 'return';
    if (!isReturn) return;

    const returnTopic = form.querySelector('[data-contact-topic="return"]');
    if (returnTopic) returnTopic.checked = true;

    const orderField = form.querySelector('[data-contact-order-field]');
    const orderInput = form.querySelector('[data-contact-order-input]');
    if (orderField) orderField.hidden = false;
    if (orderInput) {
      orderInput.disabled = false;
      orderInput.required = true;
      orderInput.setAttribute('aria-required', 'true');
    }

    const email = form.querySelector('#ContactForm-email');
    if (email) {
      email.required = true;
      email.setAttribute('aria-required', 'true');
    }

    const body = form.querySelector('[data-contact-body]');
    const copyNode = document.querySelector('[data-contact-return-copy]');
    let template = '';
    if (copyNode) {
      try {
        template = JSON.parse(copyNode.textContent);
      } catch (error) {
        template = '';
      }
    }
    if (body && template && body.value.trim() === '') {
      body.value = template;
    }

    if (orderInput && orderInput.value.trim() === '') {
      orderInput.focus();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyContactReturnIntent);
  } else {
    applyContactReturnIntent();
  }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-calendar"] && !Shopify.designMode) return;
  try {
    
  /*
    <drop-calendar-fixtures> — the client truth layer for the fixture list.

    The server renders an honest baseline (store-timezone times with a zone
    label, merchant-set status pills, a countdown aimed at the earliest
    upcoming fixture that validated at render time). Cached pages and open
    tabs drift, so this element re-checks everything on the shopper's clock:

      1. Fixture times re-render in the shopper's local timezone WITH a zone
         label, so rows and the countdown's toLocaleString date line always
         describe the same instant in the same clock.
      2. Status pills derive from the typed instants and only move FORWARD
         (upcoming -> live -> gone). The later of the merchant-set state and
         the time-derived state wins; nothing ever moves backwards and no
         state is invented for undated fixtures.
      3. The featured "Next up" panel follows the SAME resolved statuses on
         every pass, not only at connection. While its fixture is upcoming
         the clock counts; when that fixture goes live or gone the panel
         re-aims at the next future fixture or retires — it never paints
         LIVE NOW for a leftover merch date. When nothing is left to count
         toward it retires (the section's server no-upcoming state is no
         panel at all, so hidden matches it).
      4. A light 30s interval plus a visibilitychange resync re-run BOTH the
         status pass and the featured-panel pass, so mid-session rollovers
         (upcoming -> live -> gone) can never leave the panel contradicting
         a row until reload.

    Every decision comes from three pure static functions (resolveStatus,
    selectNext, planFeatured): row pills and the featured panel share one
    source of truth, and the DOM layer only writes when a state actually
    changed (steady-state passes are read-only).

    No JS: the server baseline stands (labelled store-time, merchant pills,
    and <release-countdown>'s own fail-safes cover the static clock).
  */
  class DropCalendarFixtures extends HTMLElement {
    static STATUS_RANK = { upcoming: 0, live: 1, gone: 2 };

    /**
     * Forward-only merge of the merchant-set status and the time-derived
     * one. Pure so the row painter and the featured-panel planner cannot
     * disagree. start/end are epoch ms or null (untyped / unvalidated).
     * @returns {'upcoming'|'live'|'gone'}
     */
    static resolveStatus(configured, start, end, now) {
      let derived = 'upcoming';
      if (start === null && end === null) {
        derived = configured;
      } else if (end !== null && end <= now) {
        derived = 'gone';
      } else if (start !== null && start <= now) {
        derived = 'live';
      }
      const rank = DropCalendarFixtures.STATUS_RANK;
      return (rank[derived] ?? 0) >= (rank[configured] ?? 0) ? derived : configured;
    }

    /**
     * The featured pick: minimum strictly-future start among fixtures whose
     * RESOLVED status is still upcoming (live and gone never count).
     * @param {Array<{status: string, start: number|null}>} fixtures
     * @returns {number} index into fixtures, or -1 when nothing qualifies
     */
    static selectNext(fixtures, now) {
      let best = -1;
      for (let i = 0; i < fixtures.length; i += 1) {
        const fixture = fixtures[i];
        if (fixture.status !== 'upcoming' || fixture.start === null || fixture.start <= now) continue;
        if (best === -1 || fixture.start < fixtures[best].start) best = i;
      }
      return best;
    }

    /**
     * One state machine for the "Next up" panel, applied at connection and
     * on every status pass:
     *   keep     — the featured fixture still counts down (strictly future).
     *   retarget — the featured fixture's window has passed (live or gone),
     *              or the panel has no valid fixture: aim at the next future one.
     *   retire   — nothing is left to count toward. Live fixtures stay on the
     *              row as "Live now"; the countdown panel does not fake it.
     * @param {number} featured index into fixtures, or -1
     * @param {Array<{status: string, start: number|null}>} fixtures resolved
     * @returns {object} plan: type 'keep' | 'retire', or 'retarget' + index
     */
    static planFeatured(featured, fixtures, now) {
      const current = featured >= 0 && featured < fixtures.length ? fixtures[featured] : null;
      if (current) {
        if (current.status === 'upcoming' && current.start !== null && current.start > now) {
          return { type: 'keep' };
        }
      }
      const next = DropCalendarFixtures.selectNext(fixtures, now);
      if (next === -1) return { type: 'retire' };
      return { type: 'retarget', index: next };
    }

    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-fixture-status]'));
      this.labels = {
        upcoming: this.dataset.labelUpcoming || 'Upcoming',
        live: this.dataset.labelLive || 'Live now',
        gone: this.dataset.labelGone || 'Gone',
      };
      // Adopt the server's featured pick so every later pass can follow that
      // fixture's own resolved status (null when the panel didn't render).
      this.featuredRow = this.#matchFeatured();

      this.#localizeTimes();
      this.#refresh();

      this.interval = window.setInterval(() => {
        if (!document.hidden) this.#refresh();
      }, 30000);
      this.onVisibility = () => {
        if (!document.hidden) this.#refresh();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      if (this.interval) window.clearInterval(this.interval);
      if (this.onVisibility) {
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.onVisibility = null;
      }
    }

    /**
     * Same normalisation contract as <release-countdown>: space to T, bare
     * dates get T00:00. Offset-carrying ISO strings stay one global instant.
     * @returns {Date|null} null when unparseable
     */
    #parse(raw) {
      if (!raw) return null;
      let iso = raw.trim().replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) iso += 'T00:00';
      const date = new Date(iso);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    #localizeTimes() {
      for (const row of this.rows) {
        const start = this.#parse(row.dataset.fixtureStart);
        if (!start) continue;
        const day = row.querySelector('[data-fixture-day]');
        const month = row.querySelector('[data-fixture-month]');
        const time = row.querySelector('[data-fixture-time]');
        if (day) day.textContent = String(start.getDate()).padStart(2, '0');
        if (month) month.textContent = start.toLocaleDateString(undefined, { month: 'short' });
        if (time) {
          time.textContent = start.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            timeZoneName: 'short',
          });
        }
      }
    }

    /**
     * One pass, one clock reading: resolve every row's status, paint the
     * pills, then let the featured panel follow the same resolved states.
     * Runs at connection, every 30s, and on visibility resume, so rollovers
     * (upcoming -> live -> gone) reach rows AND panel together.
     */
    #refresh() {
      const now = Date.now();
      const fixtures = this.#deriveStatuses(now);
      this.#updateFeatured(fixtures, now);
    }

    /**
     * @returns {Array<{status: string, start: number|null}>} resolved
     * fixture states, parallel to this.rows (the featured planner's input).
     */
    #deriveStatuses(now) {
      const fixtures = [];
      for (const row of this.rows) {
        const configured = row.dataset.fixtureStatus || 'upcoming';
        const start = this.#parse(row.dataset.fixtureStart);
        const end = this.#parse(row.dataset.fixtureEnd);
        const status = DropCalendarFixtures.resolveStatus(
          configured,
          start ? start.getTime() : null,
          end ? end.getTime() : null,
          now
        );
        this.#paintStatus(row, status);
        fixtures.push({ status, start: start ? start.getTime() : null });
      }
      return fixtures;
    }

    #paintStatus(row, status) {
      if (row.dataset.fixtureShown === status) return;
      row.dataset.fixtureShown = status;

      for (const state of ['upcoming', 'live', 'gone']) {
        row.classList.toggle(`drop-calendar__fixture--${state}`, state === status);
      }

      const pill = row.querySelector('[data-fixture-pill]');
      if (!pill) return;
      for (const state of ['upcoming', 'live', 'gone']) {
        pill.classList.toggle(`drop-calendar__status--${state}`, state === status);
      }

      let dot = pill.querySelector('.drop-calendar__status-dot');
      if (status === 'live' && !dot) {
        dot = document.createElement('span');
        dot.className = 'drop-calendar__status-dot';
        dot.setAttribute('aria-hidden', 'true');
        pill.prepend(dot);
      } else if (status !== 'live' && dot) {
        dot.remove();
      }

      // Swap the label text while keeping the dot element intact.
      for (const node of Array.from(pill.childNodes)) {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      }
      pill.append(this.labels[status] || status);
    }

    /**
     * The row whose fixture the server aimed the countdown at: same raw
     * instant, same configured-upcoming gate, first in block order (the
     * Liquid pick keeps the first strictly-minimal epoch).
     * @returns {Element|null}
     */
    #matchFeatured() {
      const clock = this.querySelector('[data-next-panel] release-countdown');
      if (!clock) return null;
      const raw = (clock.dataset.target || '').trim();
      if (!raw) return null;
      const match = this.rows.find(
        (row) =>
          (row.dataset.fixtureStatus || 'upcoming') === 'upcoming' &&
          (row.dataset.fixtureStart || '').trim() === raw
      );
      return match || null;
    }

    /** Apply planFeatured's verdict; steady state ("keep") writes nothing. */
    #updateFeatured(fixtures, now) {
      const panel = this.querySelector('[data-next-panel]');
      if (!panel) return;
      const clock = panel.querySelector('release-countdown');
      if (!clock) return;

      const featured = this.featuredRow ? this.rows.indexOf(this.featuredRow) : -1;
      const plan = DropCalendarFixtures.planFeatured(featured, fixtures, now);

      // keep: still counting down. Live/gone featured fixtures retire or
      // retarget so the panel never paints LIVE NOW for a leftover date.
      if (plan.type === 'keep') return;

      if (plan.type === 'retire') {
        // Nothing left to count toward. The section's server-rendered
        // no-upcoming state is no panel at all, so hiding matches it; a
        // stale clock would contradict the now-honest rows.
        if (!panel.hidden) panel.hidden = true;
        this.featuredRow = null;
        return;
      }

      // retarget: the featured window has passed, aim at the next future
      // fixture. Title follows the fixture so panel and row agree.
      const row = this.rows[plan.index];
      const raw = (row.dataset.fixtureStart || '').trim();
      this.featuredRow = row;
      if (panel.hidden) panel.hidden = false;

      const title = panel.querySelector('[data-next-title]');
      if (title) {
        const nextTitle = row.querySelector('.drop-calendar__title')?.textContent.trim() ?? '';
        if (title.textContent !== nextTitle) title.textContent = nextTitle;
      }

      // A fresh clone re-runs <release-countdown>'s connect logic against
      // the new target with clean tile/chip state (replaceWith disconnects
      // the old clock, which clears its own interval).
      const fresh = clock.cloneNode(true);
      fresh.dataset.target = raw;
      const tiles = fresh.querySelector('[data-countdown-tiles]');
      if (tiles) tiles.hidden = false;
      const chip = fresh.querySelector('[data-countdown-live]');
      if (chip) chip.hidden = true;
      const dateLine = fresh.querySelector('[data-countdown-date]');
      if (dateLine) dateLine.textContent = raw;
      clock.replaceWith(fresh);
    }
  }

  if (!customElements.get('drop-calendar-fixtures')) {
    customElements.define('drop-calendar-fixtures', DropCalendarFixtures);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    <drop-hero-slideshow> — the smart hero slideshow controller.

    Progressive enhancement: the markup already renders the first slide active
    and every other slide present but hidden via CSS (.is-active gate). Without
    this script the first slide simply stays shown — no broken state. The
    element only does real work when it carries [data-slideshow] (i.e. more than
    one slide); a lone-slide hero never gets the attribute and this class is a
    no-op for it.

    Identity-safe motion: transitions are CSS opacity cross-fades on
    --ch-ease-expo (no transforms here). Reduced motion is honoured by the CSS
    (instant cuts) AND here (autoplay never starts). The masked line reveal is
    owned entirely by the global <masked-reveal> element, which we only emit on
    the first slide — so it plays once, on the first slide, exactly as briefed.
  */
  class DropHeroSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.dataset.slideshow === undefined) return;

      this.slides = Array.from(this.querySelectorAll('.drop-hero__slide'));
      if (this.slides.length < 2) return;

      this.markers = Array.from(this.querySelectorAll('[data-marker]'));
      this.live = this.querySelector('[data-live]');
      this.ofLabel = this.dataset.of || 'of';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.index = 0;
      this.total = this.slides.length;
      this.timer = null;
      this.navigationToken = 0;
      this.navigationPending = false;
      this.mediaFailed = false;
      this.preparations = new WeakMap();
      this.pointerInside = false;
      this.focusInside = false;

      // ONE controller per connect: every listener (element- and document-
      // level) hangs off its signal, and disconnectedCallback aborts it. A
      // theme-editor section move (disconnect + reconnect of the same node)
      // therefore never stacks duplicate handlers or leaks document listeners;
      // reconnect builds a fresh controller here.
      this.listeners = new AbortController();

      this.#bindControls();
      this.#bindSwipe();
      this.#bindAutoplayGuards();
      this.#bindControlsPlacement();

      this.#syncControlsPosition();
      this.#maybeStartAuto();
    }

    disconnectedCallback() {
      this.navigationToken += 1;
      this.navigationPending = false;
      this.#stopAuto();
      this.listeners?.abort();
      this.controlsResizeObserver?.disconnect();
    }

    /** Every gate that must be open before the next slide is scheduled. */
    get #autoplayAllowed() {
      return (
        this.hasAttribute('data-autoplay') &&
        !this.reducedMotion.matches &&
        !this.pointerInside &&
        !this.focusInside &&
        !this.navigationPending &&
        !this.mediaFailed &&
        !document.hidden
      );
    }

    #bindControls() {
      const { signal } = this.listeners;
      this.querySelector('[data-prev]')?.addEventListener('click', () => {
        this.#go(this.index - 1, true);
      }, { signal });
      this.querySelector('[data-next]')?.addEventListener('click', () => {
        this.#go(this.index + 1, true);
      }, { signal });
      for (const marker of this.markers) {
        marker.addEventListener('click', () => {
          const target = Number(marker.dataset.marker) - 1;
          this.#go(target, true);
        }, { signal });
      }
      // Arrow-key control, scoped to the control bar so it never hijacks arrow
      // keys while focus is on the slide CTA or elsewhere in the hero.
      this.querySelector('[data-controls]')?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.#go(this.index - 1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.#go(this.index + 1, true);
        }
      }, { signal });
    }

    #bindSwipe() {
      const { signal } = this.listeners;
      const viewport = this.querySelector('.drop-hero__viewport');
      if (!viewport) return;

      let startX = 0;
      let startY = 0;
      let tracking = false;

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return; // touch/pen swipe only
        startX = event.clientX;
        startY = event.clientY;
        tracking = true;
      }, { signal });

      viewport.addEventListener('pointerup', (event) => {
        if (!tracking) return;
        tracking = false;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        // Horizontal intent only, past a comfortable threshold.
        if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy)) return;
        this.#go(dx < 0 ? this.index + 1 : this.index - 1, true);
      }, { signal });
    }

    #bindAutoplayGuards() {
      const { signal } = this.listeners;
      // Pause when the tab is hidden; resume (if every gate allows) on return.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.#stopAuto();
        } else {
          this.#maybeStartAuto();
        }
      }, { signal });
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) {
          this.#stopAuto();
        } else {
          this.#maybeStartAuto();
        }
      }, { signal });
      // Pause while the pointer or keyboard focus is anywhere in the carousel
      // (WCAG 2.2.2: moving content must not fight the user's attention).
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        this.pointerInside = true;
        this.#stopAuto();
      }, { signal });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'touch') return;
        this.pointerInside = false;
        this.#maybeStartAuto();
      }, { signal });
      this.addEventListener('focusin', () => {
        this.focusInside = true;
        this.#stopAuto();
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.focusInside = false;
        this.#maybeStartAuto();
      }, { signal });
    }

    /** Keep the prev/dots/next tray parked just under the active content plate. */
    #bindControlsPlacement() {
      const { signal } = this.listeners;
      const onSync = () => this.#syncControlsPosition();
      window.addEventListener('resize', onSync, { signal, passive: true });
      if (typeof ResizeObserver === 'function') {
        this.controlsResizeObserver = new ResizeObserver(onSync);
        this.controlsResizeObserver.observe(this);
        for (const slide of this.slides) {
          const content = slide.querySelector('.drop-hero__content');
          if (content) this.controlsResizeObserver.observe(content);
        }
      }
    }

    #syncControlsPosition() {
      const controls = this.querySelector('[data-controls]');
      if (!controls) return;

      // Mobile pins the tray to the bottom sheet via CSS — clear the desktop pin.
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.classList.remove('drop-hero--controls-anchored');
        this.style.removeProperty('--drop-hero-controls-top');
        return;
      }

      const content = this.slides[this.index]?.querySelector('.drop-hero__content');
      if (!content) {
        this.classList.remove('drop-hero--controls-anchored');
        this.style.removeProperty('--drop-hero-controls-top');
        return;
      }

      const heroBox = this.getBoundingClientRect();
      const contentBox = content.getBoundingClientRect();
      const gap = 12;
      const top = Math.max(0, contentBox.bottom - heroBox.top + gap);
      this.style.setProperty('--drop-hero-controls-top', `${top}px`);
      this.classList.add('drop-hero--controls-anchored');
    }

    /**
     * Move to a slide index (wraps both ends).
     * @param {number} next - target index, may be out of range
     * @param {boolean} [userInitiated] - true when a control or gesture drove it.
     *   Each completed move schedules a fresh interval when the focus, pointer,
     *   visibility, motion-preference and global-stop gates permit it.
     */
    async #go(next, userInitiated) {
      const target = (next + this.total) % this.total;
      const navigationToken = ++this.navigationToken;
      this.#stopAuto();

      if (target === this.index) {
        this.navigationPending = false;
        this.#maybeStartAuto();
        return;
      }

      this.navigationPending = true;
      const ready = await this.#prepareSlide(this.slides[target]);
      if (navigationToken !== this.navigationToken || !this.isConnected) return;

      this.navigationPending = false;
      if (!ready) {
        this.mediaFailed = true;
        this.#stopAuto();
        return;
      }

      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.markers[this.index]?.classList.remove('is-active');
      this.markers[this.index]?.removeAttribute('aria-current');

      this.index = target;

      this.slides[this.index].classList.add('is-active');
      // The visible slide is the only one exposed to assistive tech.
      this.slides[this.index].removeAttribute('aria-hidden');
      this.markers[this.index]?.classList.add('is-active');
      this.markers[this.index]?.setAttribute('aria-current', 'true');

      if (this.live && userInitiated) {
        this.live.textContent = `${this.index + 1} ${this.ofLabel} ${this.total}`;
      }

      // Content plates can differ in height per slide — re-seat the control tray.
      this.#syncControlsPosition();

      this.#maybeStartAuto();
    }

    /**
     * Hydrate one slide once, then share its readiness result across navigation.
     * @param {HTMLElement} slide
     * @returns {Promise<boolean>}
     */
    #prepareSlide(slide) {
      const existing = this.preparations.get(slide);
      if (existing) return existing;

      const preparation = this.#hydrateAndWait(slide);
      this.preparations.set(slide, preparation);
      return preparation;
    }

    /**
     * Insert deferred media and keep the current slide visible until the selected
     * responsive image (or video when no poster exists) can paint.
     * @param {HTMLElement} slide
     * @returns {Promise<boolean>}
     */
    async #hydrateAndWait(slide) {
      const template = slide.querySelector('template[data-deferred-media]');
      if (template) {
        const media = template.content.cloneNode(true);
        const mobileViewport = window.matchMedia('(max-width: 749px)').matches;
        const hasMobileImage = Boolean(media.querySelector('.drop-hero__image--mobile'));

        for (const image of media.querySelectorAll('img')) {
          const isDesktopAlternative = image.classList.contains('drop-hero__image--desktop') && hasMobileImage;
          const isMobileAlternative = image.classList.contains('drop-hero__image--mobile');
          const isSelected = (!isDesktopAlternative && !isMobileAlternative)
            || (isDesktopAlternative && !mobileViewport)
            || (isMobileAlternative && mobileViewport);
          if (isSelected) image.loading = 'eager';
        }

        template.replaceWith(media);
      }

      const images = Array.from(
        slide.querySelectorAll('img.drop-hero__image, img.drop-hero__poster, img.drop-hero__product-image')
      );
      let hasVisibleImage = false;
      for (const image of images) {
        if (window.getComputedStyle(image).display === 'none') continue;
        hasVisibleImage = true;
        if (!(await this.#waitForImage(image))) return false;
      }
      if (hasVisibleImage) return true;

      const video = slide.querySelector('video.drop-hero__video');
      if (!video) return true;
      return this.#waitForVideo(video);
    }

    /** @param {HTMLImageElement} image @returns {Promise<boolean>} */
    async #waitForImage(image) {
      if (!image.complete) {
        const loaded = await this.#waitForMediaEvent(image, 'load');
        if (!loaded) return false;
      }
      if (!image.naturalWidth) return false;

      if (typeof image.decode === 'function') {
        try {
          await image.decode();
        } catch (error) {
          return image.complete && image.naturalWidth > 0;
        }
      }
      return true;
    }

    /** @param {HTMLVideoElement} video @returns {Promise<boolean>} */
    async #waitForVideo(video) {
      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) return true;
      return this.#waitForMediaEvent(video, 'loadeddata');
    }

    /**
     * Resolve false on a media error or component disconnect.
     * @param {HTMLImageElement|HTMLVideoElement} media
     * @param {string} readyEvent
     * @returns {Promise<boolean>}
     */
    #waitForMediaEvent(media, readyEvent) {
      if (this.listeners.signal.aborted) return Promise.resolve(false);

      return new Promise((resolve) => {
        const finish = (ready) => {
          media.removeEventListener(readyEvent, onReady);
          media.removeEventListener('error', onError);
          this.listeners.signal.removeEventListener('abort', onAbort);
          resolve(ready);
        };
        const onReady = () => finish(true);
        const onError = () => finish(false);
        const onAbort = () => finish(false);

        media.addEventListener(readyEvent, onReady, { once: true });
        media.addEventListener('error', onError, { once: true });
        this.listeners.signal.addEventListener('abort', onAbort, { once: true });
      });
    }

    #maybeStartAuto() {
      this.#stopAuto();
      if (!this.#autoplayAllowed) return;
      const seconds = Number(this.dataset.interval) || 6;
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.#go(this.index + 1, false);
      }, seconds * 1000);
    }

    #stopAuto() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('drop-hero-slideshow')) {
    customElements.define('drop-hero-slideshow', DropHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-your-pair"] && !Shopify.designMode) return;
  try {
    
  /*
    <find-your-pair> — a three-step quiz state machine. Pure DOM state: the
    fieldsets, hints, results and every candidate card are server-rendered;
    this element only walks steps, scores the candidates against the picked
    answers, and toggles [hidden]. Focus follows the flow (legend on each
    step change, results heading at the end) so keyboard and screen-reader
    users always land somewhere meaningful. Neutral answers ("both"/"all")
    and neutral card tags ("both"/"all"/"any") match everything.
  */
  class FindYourPair extends HTMLElement {
    static MAX_RESULTS = 3;

    connectedCallback() {
      this.form = this.querySelector('[data-quiz-form]');
      this.steps = Array.from(this.querySelectorAll('[data-quiz-step]'));
      this.dots = Array.from(this.querySelectorAll('[data-quiz-dots] > *'));
      this.progress = this.querySelector('[data-quiz-progress]');
      this.hint = this.querySelector('[data-quiz-hint]');
      this.backButton = this.querySelector('[data-quiz-back]');
      this.nextButton = this.querySelector('[data-quiz-next]');
      this.results = this.querySelector('[data-quiz-results]');
      this.resultsHeading = this.querySelector('[data-quiz-results-heading]');
      this.resultsText = this.querySelector('[data-quiz-results-text]');
      this.resultsEmpty = this.querySelector('[data-quiz-results-empty]');
      this.cards = Array.from(this.querySelectorAll('[data-quiz-card]'));

      if (!this.form || this.steps.length === 0) return;

      this.index = 0;
      this.listeners = new AbortController();
      const { signal } = this.listeners;

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.#advance();
      }, { signal });

      this.backButton?.addEventListener('click', () => {
        if (this.index > 0) this.#showStep(this.index - 1, true);
      }, { signal });

      this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this.#restart(), { signal });

      // Picking an answer clears any "pick one" nudge straight away.
      this.form.addEventListener('change', () => {
        if (this.hint) this.hint.hidden = true;
      }, { signal });

      this.#showStep(0, false);
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    get #currentStep() {
      return this.steps[this.index];
    }

    #answerFor(step) {
      const picked = step.querySelector('input:checked');
      return picked ? picked.value : null;
    }

    #showStep(index, moveFocus) {
      this.index = index;
      this.steps.forEach((step, i) => {
        step.hidden = i !== index;
      });

      if (this.hint) this.hint.hidden = true;
      if (this.backButton) this.backButton.hidden = index === 0;
      if (this.nextButton) {
        const last = index === this.steps.length - 1;
        this.nextButton.textContent = last
          ? this.dataset.labelFinish || this.nextButton.textContent
          : this.dataset.labelNext || this.nextButton.textContent;
      }

      if (this.progress) {
        const template = this.dataset.progressTemplate || '[current]/[total]';
        this.progress.textContent = template
          .replace('[current]', String(index + 1))
          .replace('[total]', String(this.steps.length));
      }

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-current', i === index);
        dot.classList.toggle('is-done', i < index);
      });

      if (moveFocus) {
        this.#currentStep.querySelector('legend')?.focus();
      }
    }

    #advance() {
      const answer = this.#answerFor(this.#currentStep);
      if (!answer) {
        if (this.hint) {
          this.hint.hidden = false;
        }
        return;
      }

      if (this.index < this.steps.length - 1) {
        this.#showStep(this.index + 1, true);
        return;
      }

      this.#finish();
    }

    #finish() {
      const answers = {
        use: this.#answerFor(this.steps[0]),
        line: this.#answerFor(this.steps[1]),
        colour: this.#answerFor(this.steps[2]),
      };

      const NEUTRAL = ['both', 'all', 'any'];
      const neutral = (value) => !value || NEUTRAL.includes(value);
      const matches = (cardValue, answer) => neutral(answer) || neutral(cardValue) || cardValue === answer;

      // Hard gates first: only in-stock pairs (the results copy promises
      // stock), and line is a FILTER, not a score — when the shopper picked
      // men's or women's, a card tagged the other line can never appear,
      // no matter how well use/colour agree. Neutral "all" cards still pass.
      const eligible = this.cards.filter((card) => {
        if (card.dataset.available !== 'true') return false;
        if (!neutral(answers.line) && !neutral(card.dataset.line) && card.dataset.line !== answers.line) return false;
        return true;
      });

      // Use and colour are soft preferences scored within the eligible set.
      const scored = eligible.map((card, order) => {
        let score = 0;
        if (matches(card.dataset.use, answers.use)) score += 1;
        if (matches(card.dataset.colour, answers.colour)) score += 1;
        return { card, score, order };
      });

      scored.sort((a, b) => b.score - a.score || a.order - b.order);
      const winners = scored.slice(0, FindYourPair.MAX_RESULTS);

      this.cards.forEach((card) => {
        card.hidden = true;
      });
      winners.forEach(({ card }) => {
        card.hidden = false;
      });

      // With nothing eligible, swap the in-stock promise line for the
      // customer-facing fallback; the browse CTA below stays either way.
      if (this.resultsText) this.resultsText.hidden = winners.length === 0;
      if (this.resultsEmpty) this.resultsEmpty.hidden = winners.length > 0;

      this.form.hidden = true;
      if (this.results) this.results.hidden = false;

      // Late-revealed cards carry .ch-reveal; hand them to the motion layer
      // (no-op when it is absent — the CSS default is fully visible).
      if (typeof window.chObserveReveals === 'function' && this.results) {
        window.chObserveReveals(this.results);
      }

      this.resultsHeading?.focus();
    }

    #restart() {
      this.form.reset();
      this.form.hidden = false;
      if (this.results) this.results.hidden = true;
      if (this.resultsText) this.resultsText.hidden = false;
      if (this.resultsEmpty) this.resultsEmpty.hidden = true;
      this.cards.forEach((card) => {
        card.hidden = true;
      });
      this.#showStep(0, true);
    }
  }

  if (!customElements.get('find-your-pair')) {
    customElements.define('find-your-pair', FindYourPair);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
    Outside-click close for the header language pickers.

    <localization-form> already handles the disclosure itself: click to toggle,
    Escape to close and return focus, arrows/Home/End to walk the options, and
    focusout to close when focus leaves. Focusout is enough in the footer, but
    it depends on the trigger holding focus, and Safari does not focus a
    <button> on click. There, a tap anywhere beside an open header picker
    leaves the panel hanging over the page with no way back but Escape or a
    second tap on the trigger.

    So watch the pointer instead, and only for the two header placements. This
    adds a close path; it replaces nothing, and every keyboard behaviour stays
    with the shared element.
  */
  (function chCloseHeaderLocalizationOnOutsidePointer() {
    if (window.chHeaderLocalizationOutsideClose) return;
    window.chHeaderLocalizationOutsideClose = true;

    document.addEventListener('pointerdown', (event) => {
      for (const picker of document.querySelectorAll('.ch-header-lang, .ch-drawer-lang')) {
        if (picker.contains(event.target)) continue;

        const button = picker.querySelector('button.localization-form__select');
        if (button?.getAttribute('aria-expanded') !== 'true') continue;

        // hidePanel(false) leaves focus where the pointer put it, which is
        // what a click outside should do. The manual branch covers the window
        // before localization-form.js upgrades the element.
        if (typeof picker.hidePanel === 'function') {
          picker.hidePanel(false);
          continue;
        }

        button.setAttribute('aria-expanded', 'false');
        const panel = picker.querySelector('.disclosure__list-wrapper');
        if (panel) panel.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
    <image-compare> — pointer-drag enhancement over an accessible range input.

    Progressive enhancement: the range input already drives --pos through this
    script's input listener, and even the divider position is set inline on load.
    Pointer dragging anywhere on the frame is a convenience layer on top; keyboard
    users operate the native range (arrow keys) regardless. Nothing here animates
    layout — only the clip-path + divider offset move, both cheap.
  */
  class ImageCompare extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('.image-comparison__frame');
      this.range = this.querySelector('[data-range]');
      if (!this.frame || !this.range) return;

      this.range.addEventListener('input', () => this.#set(this.range.value));

      this.controller = new AbortController();
      const { signal } = this.controller;
      this.frame.addEventListener('pointerdown', this.#onDown.bind(this), { signal });
      this.frame.addEventListener('pointermove', this.#onMove.bind(this), { signal });
      this.frame.addEventListener('pointerup', this.#onUp.bind(this), { signal });
      this.frame.addEventListener('pointercancel', this.#onUp.bind(this), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    #onDown(event) {
      this.dragging = true;
      this.frame.setPointerCapture?.(event.pointerId);
      this.#fromPointer(event);
    }

    #onMove(event) {
      if (!this.dragging) return;
      this.#fromPointer(event);
    }

    #onUp(event) {
      this.dragging = false;
      this.frame.releasePointerCapture?.(event.pointerId);
    }

    #fromPointer(event) {
      const rect = this.frame.getBoundingClientRect();
      if (!rect.width) return;
      const ratio = (event.clientX - rect.left) / rect.width;
      const pct = Math.min(Math.max(ratio * 100, 0), 100);
      this.range.value = String(pct);
      this.#set(pct);
    }

    #set(value) {
      this.style.setProperty('--pos', `${value}%`);
    }
  }

  if (!customElements.get('image-compare')) {
    customElements.define('image-compare', ImageCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.size-guide__dialog');
      if (!this.dialog) return;

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.querySelectorAll('[data-size-guide-open]').forEach((el) => {
        el.addEventListener('click', () => this.open(), { signal });
      });
      this.querySelectorAll('[data-size-guide-close]').forEach((el) => {
        el.addEventListener('click', () => this.dialog.close(), { signal });
      });

      // Close when the backdrop (the dialog element itself) is clicked.
      this.dialog.addEventListener(
        'click',
        (event) => {
          if (event.target === this.dialog) this.dialog.close();
        },
        { signal }
      );

      // Let a sibling size-selector open this guide via a bubbled event.
      const root = this.closest('.product__info-container') || document;
      root.addEventListener('size-guide:open', () => this.open(), { signal });

      this.querySelectorAll('[data-pdp-share]').forEach((button) => {
        button.addEventListener('click', () => this.share(button), { signal });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    open() {
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    async share(button) {
      const url = button.getAttribute('data-share-url') || window.location.href;
      const title = button.getAttribute('data-share-title') || document.title;

      if (typeof navigator.share === 'function') {
        try {
          await navigator.share({ url, title });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }

      await this.copyShare(button, url);
    }

    async copyShare(button, url) {
      try {
        await navigator.clipboard.writeText(url);
      } catch (error) {
        return;
      }

      const label = button.querySelector('[data-share-label]');
      const status = button.querySelector('[data-share-status]');
      const copied = button.getAttribute('data-copied-label');
      const previous = label ? label.textContent : '';

      if (label && copied) label.textContent = copied;
      if (status) status.textContent = copied || '';

      window.setTimeout(() => {
        if (label) label.textContent = previous;
        if (status) status.textContent = '';
      }, 1600);
    }
  }

  if (!customElements.get('size-guide')) {
    customElements.define('size-guide', SizeGuide);
  }

  class ShippingReturns extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.animations = new WeakMap();
      this.classList.add('shipping-returns--js');

      this.querySelectorAll('details[open] .shipping-returns__body').forEach((body) => {
        body.style.height = 'auto';
      });

      this.querySelectorAll('.shipping-returns__summary').forEach((summary) => {
        summary.addEventListener('click', (event) => this.onSummaryClick(event), { signal });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    onSummaryClick(event) {
      const panel = event.currentTarget.closest('details');
      if (!panel) return;
      event.preventDefault();

      if (panel.open) {
        this.closePanel(panel);
        return;
      }

      this.querySelectorAll('details[open]').forEach((openPanel) => {
        if (openPanel !== panel) this.closePanel(openPanel);
      });
      this.openPanel(panel);
    }

    animateBody(body, from, to) {
      const previous = this.animations.get(body);
      if (previous) previous.cancel();
      body.style.height = from;
      const animation = body.animate([{ height: from }, { height: to }], {
        duration: from === '0px' ? 220 : 180,
        easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
        fill: 'forwards',
      });
      this.animations.set(body, animation);
      return animation;
    }

    openPanel(panel) {
      const body = panel.querySelector('.shipping-returns__body');
      panel.open = true;
      if (!body || this.reduceMotion) {
        if (body) body.style.height = 'auto';
        return;
      }

      const from = `${body.getBoundingClientRect().height}px`;
      const to = `${body.scrollHeight}px`;
      const animation = this.animateBody(body, from, to);
      animation.finished
        .then(() => {
          if (this.animations.get(body) !== animation) return;
          body.style.height = 'auto';
          animation.cancel();
          this.animations.delete(body);
        })
        .catch(() => {
          if (this.animations.get(body) !== animation) return;
          body.style.height = 'auto';
        });
    }

    closePanel(panel) {
      const body = panel.querySelector('.shipping-returns__body');
      if (!body || this.reduceMotion) {
        panel.open = false;
        if (body) body.style.height = '';
        return;
      }

      const from = `${body.getBoundingClientRect().height}px`;
      const animation = this.animateBody(body, from, '0px');
      animation.finished
        .then(() => {
          if (this.animations.get(body) !== animation) return;
          panel.open = false;
          body.style.height = '';
          animation.cancel();
          this.animations.delete(body);
        })
        .catch(() => {
          if (this.animations.get(body) !== animation) return;
          panel.open = false;
          body.style.height = '';
        });
    }
  }

  if (!customElements.get('shipping-returns')) {
    customElements.define('shipping-returns', ShippingReturns);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  /*
    <newsletter-signup> — decides whether THIS form owns the current postback.

    Shopify keys form.posted_successfully? and form.errors to the form_type,
    not to an individual customer form: every customer form on the page renders
    the same postback state, so the footer bar and the promo popup light up
    together. The one reliable signal is the URL fragment — a customer form
    posts to /contact#<form id> and the browser re-applies that fragment to
    the redirect, so location.hash names the form that was actually sent.

    Rule: only drop our postback block when the fragment resolves to a
    DIFFERENT form element. An empty or non-form fragment means "can't tell",
    and then we leave the message alone — a browser that drops the fragment
    must never swallow a real confirmation.
  */
  class NewsletterSignup extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      const blocks = this.querySelectorAll('[data-postback]');
      if (!form || blocks.length === 0) return;

      const input = this.querySelector('input[type="email"]');
      const fragment = window.location.hash.slice(1);
      const targeted = fragment ? document.getElementById(fragment) : null;

      if (targeted && targeted.tagName === 'FORM' && targeted !== form) {
        for (const block of blocks) block.remove();
        input?.removeAttribute('aria-invalid');
        input?.removeAttribute('aria-describedby');
        return;
      }

      // Ours: move focus the way the old autofocus attribute did — but from
      // script, so it can never fire for a submission that wasn't ours.
      const success = this.querySelector('[data-postback="success"]');
      if (success) {
        success.focus();
        return;
      }
      if (this.querySelector('[data-postback="error"]')) input?.focus();
    }
  }

  if (!customElements.get('newsletter-signup')) {
    customElements.define('newsletter-signup', NewsletterSignup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  class RecentlyViewed extends HTMLElement {
    static STORAGE_KEY = 'rs:recently-viewed';

    connectedCallback() {
      this.grid = this.querySelector('[data-recently-viewed-grid]');
      this.currentHandle = this.dataset.currentHandle || '';
      this.limit = parseInt(this.dataset.limit, 10) || 8;
      this.sectionId = this.dataset.sectionId;
      this.productBase = this.dataset.productUrl || '/products/';

      // Record this PDP view immediately (cheap, storage-only)…
      this.record();

      // …but DON'T fetch anything yet. Each history card is a full section
      // render on the server, so the burst of requests waits until the section
      // actually approaches the viewport. Fetches are tied to an
      // AbortController so a disconnect (theme editor reload, quick
      // navigation) cancels anything still in flight.
      this.aborter = new AbortController();
      if ('IntersectionObserver' in window) {
        // Start ~1200px ahead so cards exist before the eyes arrive.
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.render();
          },
          { rootMargin: '1200px 0px' }
        );
        this.observer.observe(this);

        // Delivery guarantee: a fast flick can carry this zero-height element
        // across the observer's bounds between two frames without ever
        // intersecting, leaving the section empty forever. When scrolling
        // pauses, render if the section sits near or above the viewport.
        this.scrollAborter = new AbortController();
        window.addEventListener('scroll', () => this.scheduleIdleCheck(), {
          passive: true,
          signal: this.scrollAborter.signal,
        });
      } else {
        this.render();
      }
    }

    scheduleIdleCheck() {
      if (this.idleTimer) window.clearTimeout(this.idleTimer);
      this.idleTimer = window.setTimeout(() => {
        const rect = this.getBoundingClientRect();
        if (rect.top < window.innerHeight + 1200) this.render();
      }, 200);
    }

    teardownTriggers() {
      this.observer?.disconnect();
      this.observer = null;
      this.scrollAborter?.abort();
      this.scrollAborter = null;
      if (this.idleTimer) {
        window.clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    }

    disconnectedCallback() {
      this.teardownTriggers();
      this.aborter?.abort();
    }

    read() {
      try {
        const raw = window.localStorage.getItem(RecentlyViewed.STORAGE_KEY);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list)
          ? list.filter((handle) => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle))
          : [];
      } catch (error) {
        return [];
      }
    }

    write(list) {
      try {
        window.localStorage.setItem(RecentlyViewed.STORAGE_KEY, JSON.stringify(list));
      } catch (error) {
        // Storage unavailable/full — degrade silently, the feature just no-ops.
      }
    }

    record() {
      if (!this.currentHandle) return;
      const next = [this.currentHandle, ...this.read().filter((h) => h !== this.currentHandle)];
      this.write(next.slice(0, 24));
    }

    async render() {
      // Both triggers (observer + scroll-idle fallback) route here; render once.
      if (this.renderRequested) return;
      this.renderRequested = true;
      this.teardownTriggers();

      // The stored history minus the product we're already looking at.
      const handles = this.read()
        .filter((handle) => handle !== this.currentHandle)
        .slice(0, this.limit);

      if (!handles.length) return;

      // Modest concurrency (4 at a time) instead of firing every request at
      // once — the history can hold up to 12 full section renders.
      const cards = [];
      for (let i = 0; i < handles.length; i += 4) {
        const batch = await Promise.all(handles.slice(i, i + 4).map((handle) => this.fetchCard(handle)));
        cards.push(...batch);
        if (this.aborter.signal.aborted) return;
      }
      const found = cards.filter(Boolean);
      if (!found.length || !this.isConnected) return;

      found.forEach((node) => this.grid.appendChild(node));
      this.hidden = false;

      // Cards carry `.ch-reveal` (resting state: opacity 0). They were injected
      // after obsidian-motion.js already ran its initial scan, so ask it to
      // observe the new nodes — otherwise they'd stay invisible forever. If the
      // hook isn't present (motion JS absent), strip the class so the cards fall
      // back to fully visible rather than staying hidden.
      if (typeof window.chObserveReveals === 'function') {
        window.chObserveReveals(this.grid);
      } else {
        this.grid.querySelectorAll('.ch-reveal').forEach((el) => el.classList.remove('ch-reveal'));
      }
    }

    async fetchCard(handle) {
      try {
        const url = new URL(`${this.productBase}${encodeURIComponent(handle)}`, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const response = await fetch(url, { signal: this.aborter.signal });
        if (!response.ok) return null;

        const markup = await response.text();
        const doc = new DOMParser().parseFromString(markup, 'text/html');
        const template = doc.querySelector('[data-recently-viewed-card]');
        const item = template && template.content.firstElementChild;
        return item ? document.importNode(item, true) : null;
      } catch (error) {
        // Unresolvable handle (unpublished/deleted) — skip it, keep the rest.
        return null;
      }
    }
  }

  if (!customElements.get('recently-viewed')) {
    customElements.define('recently-viewed', RecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-band"] && !Shopify.designMode) return;
  try {
    
  /*
    <count-up> — a tiny, dependency-free scroll-triggered number roll.

    Progressive enhancement: the element's initial text content is already the
    final value, so with no JS, no IntersectionObserver, or reduced motion, the
    figure simply shows its final number — zero layout shift, nothing broken.
    When it scrolls into view it animates once from 0 to data-to, honouring
    data-decimals for fractional figures (e.g. 4.9). It never re-runs.
  */
  class CountUp extends HTMLElement {
    connectedCallback() {
      this.target = parseFloat(this.dataset.to);
      this.decimals = Number(this.dataset.decimals) || 0;

      // A word rather than a number (e.g. "Fast") → leave the text untouched.
      // Rendering it would print the literal string "NaN".
      if (Number.isNaN(this.target)) return;

      // No support or reduced motion → leave the final value.
      if (
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        this.#render(this.target);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.#run();
              this.observer.disconnect();
              this.observer = null;
              break;
            }
          }
        },
        { threshold: 0.4 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #run() {
      const duration = 1400;
      const start = performance.now();
      // easeOutExpo — matches the theme's signature curve.
      const ease = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        this.#render(this.target * ease(progress));
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          this.#render(this.target);
        }
      };
      requestAnimationFrame(tick);
    }

    #render(value) {
      this.textContent = value.toFixed(this.decimals);
    }
  }

  if (!customElements.get('count-up')) {
    customElements.define('count-up', CountUp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-showcase')) {
    class VideoShowcase extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.cards = Array.from(this.querySelectorAll('[data-video-card]'))
          .map((item, index) => ({
            item,
            video: item.querySelector('video'),
            toggle: item.querySelector('[data-video-toggle]'),
            toggleLabel: item.querySelector('[data-video-toggle-label]'),
            state: item.querySelector('[data-video-state]'),
            inView: false,
            wantsAudio: false,
            sourceAttached: false,
            analyticsPlayed: false,
            analyticsIndex: index + 1,
          }))
          .filter((card) => card.video && card.toggle);

        if (!this.cards.length) return;

        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.calmQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        for (const card of this.cards) {
          // The scripted chrome takes over from the native controls the no-JS
          // path relies on.
          card.video.removeAttribute('controls');
          card.video.muted = true;
          card.video.defaultMuted = true;
          this.sync(card);

          card.video.addEventListener(
            'play',
            () => {
              this.sync(card);
              this.trackPlay(card);
            },
            { signal }
          );
          card.video.addEventListener('volumechange', () => this.sync(card), { signal });
          // A refused unmuted play arrives here as a pause nobody asked for.
          // Fall back to muted rather than leaving the card dead.
          card.video.addEventListener(
            'pause',
            () => {
              if (card.wantsAudio) {
                this.fallbackToMuted(card);
                return;
              }
              this.sync(card);
            },
            { signal }
          );

          card.item.addEventListener(
            'pointerenter',
            (event) => {
              if (event.pointerType === 'touch' || !this.hoverQuery.matches) return;
              this.activate(card);
            },
            { signal }
          );
          card.item.addEventListener(
            'pointerleave',
            (event) => {
              if (event.pointerType === 'touch' || !this.hoverQuery.matches) return;
              this.deactivate(card);
            },
            { signal }
          );

          // Keyboard focus exposes the control without starting sound. Enter
          // or Space reaches the click handler below and remains the explicit
          // activation step.
          card.item.addEventListener(
            'focusin',
            (event) => {
              if (!this.isKeyboardFocus(event.target)) return;
              this.sync(card);
            },
            { signal }
          );
          card.item.addEventListener(
            'focusout',
            (event) => {
              if (card.item.contains(event.relatedTarget)) return;
              this.deactivate(card);
            },
            { signal }
          );

          card.toggle.addEventListener(
            'click',
            () => {
              if (card.wantsAudio) {
                this.deactivate(card);
                return;
              }
              this.activate(card);
            },
            { signal }
          );
        }

        this.loadObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const card = this.cards.find((candidate) => candidate.item === entry.target);
            if (!card) continue;
            this.attachSource(card);
            this.loadObserver.unobserve(card.item);
          }
        }, { rootMargin: '320px 0px', threshold: 0 });

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            const card = this.cards.find((candidate) => candidate.item === entry.target);
            if (!card) continue;
            card.inView = entry.isIntersecting;
            if (card.inView) {
              this.loop(card);
            } else {
              this.stop(card);
            }
          }
        }, { threshold: 0.15 });
        for (const card of this.cards) {
          this.loadObserver.observe(card.item);
          this.observer.observe(card.item);
        }

        document.addEventListener(
          'visibilitychange',
          () => {
            for (const card of this.cards) {
              if (document.hidden) {
                this.stop(card);
              } else {
                this.loop(card);
              }
            }
          },
          { signal }
        );

        // Flipping the motion preference mid-session has to take effect now,
        // not on the next page load.
        this.calmQuery.addEventListener(
          'change',
          () => {
            for (const card of this.cards) {
              if (card.wantsAudio) continue;
              if (this.calmQuery.matches) {
                this.stop(card);
              } else {
                this.loop(card);
              }
            }
          },
          { signal }
        );

        this.setAttribute('data-upgraded', '');
      }

      disconnectedCallback() {
        if (this.cards) {
          for (const card of this.cards) this.stop(card);
        }
        if (this.loadObserver) this.loadObserver.disconnect();
        if (this.observer) this.observer.disconnect();
        if (this.controller) this.controller.abort();
      }

      attachSource(card) {
        if (card.sourceAttached) return;
        const url = card.video.dataset.videoSrc;
        if (!url) return;
        const source = document.createElement('source');
        source.src = url;
        source.type = card.video.dataset.videoType || 'video/mp4';
        card.video.append(source);
        card.video.load();
        card.sourceAttached = true;
      }

      // A quiet muted loop is the card's resting state. Reduced motion removes
      // it: nothing there may start moving on its own.
      canLoop(card) {
        return !this.calmQuery.matches && card.inView && !document.hidden;
      }

      loop(card) {
        if (card.wantsAudio || !this.canLoop(card)) return;
        this.attachSource(card);
        card.video.muted = true;
        const attempt = card.video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => this.sync(card));
        }
        this.sync(card);
      }

      // Hover, keyboard focus or a press on the button: this card, and only this
      // card, plays with sound.
      activate(card) {
        if (document.hidden) return;
        this.attachSource(card);
        for (const other of this.cards) {
          if (other !== card && other.wantsAudio) this.deactivate(other);
        }
        card.wantsAudio = true;
        const video = card.video;
        video.muted = false;
        this.sync(card);
        const attempt = video.play();
        if (!attempt || typeof attempt.then !== 'function') {
          this.sync(card);
          return;
        }
        attempt
          .then(() => {
            // Some browsers resolve the promise and then mute or pause the
            // element themselves. Report what happened, not what we asked for.
            if (card.wantsAudio && (video.muted || video.paused)) {
              this.fallbackToMuted(card);
              return;
            }
            this.sync(card);
          })
          .catch(() => this.fallbackToMuted(card));
      }

      // The audio stops. A motion-friendly card drops back to its muted loop;
      // a reduced-motion or off-screen card stops on its poster.
      deactivate(card) {
        card.wantsAudio = false;
        card.analyticsPlayed = false;
        card.video.muted = true;
        if (!this.canLoop(card)) card.video.pause();
        this.sync(card);
      }

      // Autoplay policy refused the sound before a real user gesture. Keep the
      // card working muted and let the indicator say so.
      fallbackToMuted(card) {
        card.wantsAudio = false;
        card.analyticsPlayed = false;
        card.video.muted = true;
        this.sync(card);
        this.loop(card);
      }

      stop(card) {
        card.wantsAudio = false;
        card.analyticsPlayed = false;
        card.video.muted = true;
        card.video.pause();
        this.sync(card);
      }

      isKeyboardFocus(element) {
        if (!element || typeof element.matches !== 'function') return false;
        try {
          return element.matches(':focus-visible');
        } catch (error) {
          return false;
        }
      }

      trackPlay(card) {
        if (!this.closest('.video-showcase--compact') || !this.dataset.productId) return;
        if (!card.wantsAudio || card.analyticsPlayed) return;
        card.analyticsPlayed = true;
        this.publishPdpEvent('pdp_video_played', {
          productId: this.dataset.productId,
          videoIndex: card.analyticsIndex,
        });
      }

      publishPdpEvent(name, payload) {
        if (typeof window.defaultAnimalPdpPublish === 'function') {
          window.defaultAnimalPdpPublish(name, payload);
          return;
        }
        try {
          const privacy = window.Shopify?.customerPrivacy;
          const analytics = window.Shopify?.analytics;
          if (typeof privacy?.analyticsProcessingAllowed !== 'function') return;
          if (privacy.analyticsProcessingAllowed() !== true || typeof analytics?.publish !== 'function') return;
          const publishResult = analytics.publish(`default_animal:${name}`, payload);
          if (publishResult && typeof publishResult.catch === 'function') {
            publishResult.catch(() => {});
          }
        } catch {
          return;
        }
      }

      label(name, fallback) {
        return this.getAttribute(name) || fallback;
      }

      // One source of truth: a card is audible only while an unmuted video is
      // actually running.
      sync(card) {
        const audible = !card.video.muted && !card.video.paused;
        card.item.setAttribute('data-audio', audible ? 'audible' : 'muted');
        if (card.toggleLabel) {
          card.toggleLabel.textContent = audible
            ? this.label('data-label-sound-off', 'Stop sound')
            : this.label('data-label-sound-on', 'Play with sound');
        }
        if (card.state) {
          card.state.textContent = audible
            ? this.label('data-label-state-audible', 'Sound on')
            : this.label('data-label-state-muted', 'Sound off');
        }
      }
    }

    customElements.define('video-showcase', VideoShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
